import { render, staticRenderFns } from "./FaceDirectionResultEffectIconFailure.vue?vue&type=template&id=0d346758&scoped=true&"
import script from "./FaceDirectionResultEffectIconFailure.vue?vue&type=script&lang=ts&"
export * from "./FaceDirectionResultEffectIconFailure.vue?vue&type=script&lang=ts&"
import style0 from "./FaceDirectionResultEffectIconFailure.vue?vue&type=style&index=0&id=0d346758&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d346758",
  null
  
)

export default component.exports